import { z } from "zod";
import {
  directoryRoleSchema,
  directorySortBySchema,
  directorySortDirSchema,
  directoryStatusSchema,
  employmentTypeSchema,
  membershipAddedViaSchema,
  workModeSchema,
} from "@/shared/membership/directory.schema";

/** URL search-params schema for `/workspace/people`. */
export const peopleDirectorySearchSchema = z
  .object({
    search: z.string().optional(),
    role: directoryRoleSchema.optional(),
    employmentType: employmentTypeSchema.optional(),
    workMode: workModeSchema.optional(),
    addedVia: membershipAddedViaSchema.optional(),
    departmentId: z.string().optional(),
    status: directoryStatusSchema.catch("all").default("all"),
    /** Selected row IDs (membershipId for active rows, invitationId for invited
     *  rows). Comma-joined. URL-state per S3. */
    selected: z.string().optional(),
    sortBy: directorySortBySchema.catch("displayName").default("displayName"),
    sortDir: directorySortDirSchema.catch("asc").default("asc"),
  })
  .strict();

export type PeopleDirectorySearch = z.infer<typeof peopleDirectorySearchSchema>;

/** True if any user-applied filter narrows the result set. Status counts when
 * it has been changed away from the default "all". */
export function hasDirectoryFilter(s: PeopleDirectorySearch): boolean {
  return Boolean(
    s.search ||
      s.role ||
      s.employmentType ||
      s.workMode ||
      s.addedVia ||
      s.departmentId ||
      (s.status && s.status !== "all"),
  );
}
